export const state = initialState();

// state is a function so it can be instantiated again - reset
function initialState() {
  return {
    isNutritionUpdated: true,
  };
}

export const getters = {};

export const mutations = {
  setIsNutritionUpdated(state, value) {
    state.isNutritionUpdated = value;
  },
  reset(state) {
    // acquire initial state
    const s = initialState();
    Object.keys(s).forEach((key) => {
      state[key] = s[key];
    });
  },
};

export const actions = {};
